import { PATH } from './path';

/** 스마트검색 버튼을 띄우고 TWC 챗봇은 숨기는 메뉴 경로 */
export const SMART_SEARCH_MENU_PATHS = [PATH.DELIVERY_AGENCY, PATH.CLAIM_COLLECTING] as const;

/**
 * 스마트검색 API 공통 필수 파라미터
 * - FAQ 조회, 검색, 피드백 전송 API에서 공통 사용
 */
export const SMART_SEARCH_PARAMS = {
  PRODUCT_CODE: 'KLS',
  SERVICE_TYPE: 'DELIVERY_AGENCY',
} as const;

/** 스마트검색 담당자 연락처 */
export const SMART_SEARCH_PHONE_NUMBER = '1833-3165';
